module.exports = __webpack_public_path__ + "media/images/magic-icon-bfbadec7003cf921c31f5f23ab271788.png";